import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { FlightListScope } from '../domain/constants/FlightListScope';
import { Color } from '../../../../styles/Color';
import { getFlightsListUrl } from '../../use-cases/getFlightsListUrl';
import { useFlightStores } from '../../shared/context/flightStoresContext';
import { RouterLink } from '../../../../components/common/link/RouterLink';
import { Css, ITheme, Responsive } from '../../../../ui';
import { AirportCodes } from '../../../../types/airports';

interface IFlightScopeToggleProps {
	airport: AirportCodes;
}

export const FlightsScopeToggle = observer(
	({ airport }: IFlightScopeToggleProps) => {
		const { flightListStore } = useFlightStores();
		const { query, scope } = flightListStore;

		return (
			<ToggleList>
				<li className="no-max-width">
					<StyledToggleLink
						href={getFlightsListUrl(airport, FlightListScope.Departures, query)}
						aria-label="View Departures"
						scroll={false}
						shallow
						aria-current={
							scope === FlightListScope.Departures ? 'page' : undefined
						}
					>
						<h4>Departures</h4>
					</StyledToggleLink>
				</li>
				<li className="no-max-width">
					<StyledToggleLink
						href={getFlightsListUrl(airport, FlightListScope.Arrivals, query)}
						aria-label="View Arrivals"
						scroll={false}
						shallow
						aria-current={
							scope === FlightListScope.Arrivals ? 'page' : undefined
						}
					>
						<h4>Arrivals</h4>
					</StyledToggleLink>
				</li>
			</ToggleList>
		);
	},
);

export const ToggleList = styled.ul`
	display: flex;
	margin: 0;
	padding: 0;
	list-style: none;
	gap: ${Css.pxToRem(24)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		gap: ${Css.pxToRem(16)};
	}
`;

export const StyledToggleLink = styled(RouterLink)<{}, ITheme>`
	text-decoration: none;

	h4 {
		margin: 0;
		color: ${Color.Neutral6};
	}

	&[aria-current='page'] {
		h4 {
			border-bottom: 2px solid ${(props) => props.theme.color.secondaryLight};
			color: ${(props) => props.theme.color.secondaryLight};
		}
	}

	&:hover,
	&:active {
		h4 {
			color: ${(props) => props.theme.color.secondaryLight};
		}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		h4 {
			font-size: ${Css.pxToRem(20)};
		}
	}
`;
